import { render } from "./column-payrate.vue?vue&type=template&id=30a0cfc8"
import script from "./column-payrate.vue?vue&type=script&lang=js"
export * from "./column-payrate.vue?vue&type=script&lang=js"

import "./column-payrate.vue?vue&type=style&index=0&id=30a0cfc8&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__